import { render } from "./newAssureur.vue?vue&type=template&id=0e3960a5&scoped=true"
import script from "./newAssureur.vue?vue&type=script&lang=js"
export * from "./newAssureur.vue?vue&type=script&lang=js"

import "./newAssureur.vue?vue&type=style&index=0&id=0e3960a5&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3960a5"]])

export default __exports__